document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('[data-article-content]');
  var tocList = document.querySelector('[data-article-toc-list]');
  var toc = document.querySelector('[data-article-toc]');

  if (content && tocList) {
    var headings = content.querySelectorAll('h2, h3');

    if (headings.length === 0) {
      if (toc) toc.hidden = true;
    } else {
      var usedIds = {};
      var links = [];

      headings.forEach(function (heading, index) {
        if (!heading.id) {
          var slug = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
          if (!slug) slug = 'section';
          if (usedIds[slug]) {
            usedIds[slug] += 1;
            slug = slug + '-' + usedIds[slug];
          } else {
            usedIds[slug] = 1;
          }
          heading.id = slug;
        }

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent.trim();
        a.className = 'article-toc__link' + (heading.tagName === 'H3' ? ' article-toc__link--sub' : '');
        li.appendChild(a);
        tocList.appendChild(li);
        links.push({ heading: heading, link: a });
      });

      var setActive = function (heading) {
        links.forEach(function (item) {
          item.link.classList.toggle('is-active', item.heading === heading);
        });
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActive(entry.target);
              }
            });
          },
          { rootMargin: '-10% 0px -70% 0px', threshold: 0 }
        );
        headings.forEach(function (heading) {
          observer.observe(heading);
        });
      }

      setActive(headings[0]);
    }
  }
});
